(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8649],{

/***/ 64597:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/[category_id]",
      function () {
        return __webpack_require__(23366);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ page; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var page = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    pageId: -1,
    isMobile: 0,
    isTablet: 0,
    isDesktop: 0,
    isPublicDomain: 0,
    appSettings: [],
    destinationId: null,
    propertiesParams: {
        page_id: null,
        limit: 24,
        offset: 0,
        destinations: [],
        tags: [],
        themes: [],
        locations: [],
        statuses: 3
    }
});


/***/ }),

/***/ 23366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_AppContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7108);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55791);
/* harmony import */ var _fancyapps_ui_dist_fancybox_esm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53569);
/* harmony import */ var _layouts_MainLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66331);







var Articles = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1451), __webpack_require__.e(4366), __webpack_require__.e(2778), __webpack_require__.e(4972), __webpack_require__.e(1964), __webpack_require__.e(4176), __webpack_require__.e(3074), __webpack_require__.e(2411), __webpack_require__.e(2000), __webpack_require__.e(8202), __webpack_require__.e(7540), __webpack_require__.e(7094)]).then(__webpack_require__.bind(__webpack_require__, 87540));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87540)
            ];
        }
    },
    suspense: true
});


var __N_SSP = true;
function Home(props) {
    var pageContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_components_AppContext__WEBPACK_IMPORTED_MODULE_3__/* .page */ .M);
    pageContext.pageId = props.app_data.page_id;
    pageContext.isMobile = props.isMobile;
    pageContext.isTablet = props.isTablet;
    pageContext.isDesktop = props.isDesktop;
    pageContext.appSettings = props.app;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), urlHref = ref[0], setUrlHref = ref[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (window !== undefined) {
            setUrlHref(window.location.href + "/");
        }
    }, [
        urlHref
    ]);
    var domain = props.domain;
    var app_data = props.app_data;
    var app = props.app;
    var head = props.head;
    var footer = props.footer;
    var locations = props.locations;
    var navigation = props.navigation;
    var content = props.content;
    var rgbDesignColor = props.rgbDesignColor;
    var rgbSearchbarColor = props.rgbSearchbarColor;
    var isDesktop = props.isDesktop;
    var builder = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].objChildExists */ .Z.objChildExists(app, "builder") ? app.builder : null;
    var image_fb_meta = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_4__/* ["default"].isValidArray */ .Z.isValidArray(head.og_image) ? head.og_image[0].image : null;
    var contactIcons = {
        phoneIcon: app.showPhoneIconOnMenu,
        chatIcon: app.showChatIconOnMenu,
        mailIcon: app.showMailIconOnMenu,
        phoneIconData: app.menuPhoneIconData,
        chatIconData: app.menuChatIconData,
        mailIconData: app.menuMailIconData
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (window !== undefined) {
            window.designMode = app.designMode;
        }
        _fancyapps_ui_dist_fancybox_esm__WEBPACK_IMPORTED_MODULE_5__/* .Fancybox.bind */ .KR.bind("[data-fancybox]", {
            Image: {
                zoom: false
            }
        });
    });
    var captchaSiteKey = "6Ldn5jYUAAAAAHV8v0apDoa8Hd1O67fo92WqpWRY";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_MainLayout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Articles, {
                type: "category",
                isArticle: false,
                isArticleCategory: true,
                isBlogArticle: false,
                domain: domain,
                app_data: app_data,
                app: app,
                head: head,
                footer: footer,
                locations: locations,
                navigation: navigation,
                content: content,
                rgbDesignColor: rgbDesignColor,
                rgbSearchbarColor: rgbSearchbarColor,
                isDesktop: isDesktop,
                image_fb_meta: image_fb_meta,
                contactIcons: contactIcons,
                urlHref: urlHref,
                builder: builder,
                htmlSections: props.html_sections
            })
        })
    }));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5726,2828,8051,3512,7948,571,75,1682,3445,1651,6331,9774,2888,179], function() { return __webpack_exec__(64597); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);